export default "__VITE_ASSET__ClQ5h8vB__"